/**
 * Shows its children only to somebody who may do `do` on this screen (or on
 * `on`, another one) - see utils/permissions. The server refuses the same
 * thing anyway; this keeps a button that would only be refused off the page.
 *
 *   <Can do="create"><Button>Add</Button></Can>
 *   <Can do="export" on="orders">...</Can>
 */

import PropTypes from "prop-types";
import { useCan } from "utils/permissions";

function Can({ do: action, on, children }) {
  const allowed = useCan();
  return allowed(action, on || undefined) ? children : null;
}

Can.defaultProps = { on: null, children: null };

Can.propTypes = {
  do: PropTypes.string.isRequired,
  on: PropTypes.string,
  children: PropTypes.node,
};

export default Can;
